module.exports = __webpack_public_path__ + "media/phytic-medium.2fab11d2.mp4";